<modal-container
  #modalHsSyncInOrder
  [headerIconClass]=""
  [headerTitle]="
    modalContent === 'search-tabs'
      ? 'purchaseOrder.productSearch.header'
      : modalContent === 'connect-choose'
        ? 'purchaseOrder.product.searchHs.header'
        : ''
  "
  [isExtraLargeModal]="true"
  [hasBackdrop]="true"
  [ignoreBackdropClick]="!allowBackdropClick"
  [isModalInModal]="true"
  [isHideBtnHidden]="true"
>
  <ng-container class="modal-button-show">
    <form-row-input
      [label]="'purchase-orders.search'"
      [model]="searchPhrase"
      (onFocused)="showModalAndFocusOnSearchInput()"
      (modelChange)="updateSearchValue($event)"
    ></form-row-input>
  </ng-container>

  <!--  default content - search for own or hs products:-->
  <ng-container class="modal-body-content" *ngIf="modalContent === 'search-tabs'">
    <div>
      <div class="mb-2">
        <span class="text-sm font-weight-bold gray mr-1"
          >{{ 'purchaseOrder.productSearch.subheader.a1' | translate }}:</span
        >
        <span class="text-sm gray">{{ 'purchaseOrder.productSearch.subheader.a2' | translate }}</span>
      </div>
      <div class="mb-4">
        <span class="text-sm font-weight-bold gray mr-1"
          >{{ 'purchaseOrder.productSearch.subheader.b1' | translate }}:</span
        >
        <span class="text-sm gray">{{ 'purchaseOrder.productSearch.subheader.b2' | translate }}</span>
      </div>
    </div>
    <div class="d-flex flex-row">
      <div
        class="btn-tab-card-top"
        [ngClass]="{ active: searchTab === 'own' }"
        (click)="switchTab('own')"
        (keyup)="switchTab('own')"
        tabindex="-1"
      >
        {{ 'purchaseOrder.productSearch.tab.own' | translate }}
      </div>
      <div
        class="btn-tab-card-top"
        [ngClass]="{ active: searchTab === 'hs' }"
        (click)="switchTab('hs')"
        (keyup)="switchTab('hs')"
        tabindex="-1"
      >
        {{ 'purchaseOrder.productSearch.tab.hs' | translate }}
      </div>
    </div>
    <div class="card card-flat-top">
      <div class="row" *ngIf="searchTab === 'own'">
        <div class="col-12">
          <form-row-input
            #searchInputInModal
            [label]="'automatic-orders.product.search' | translate"
            [model]="searchPhrase"
            (modelChange)="searchPhrase = $event; productSearchChange()"
            [appendBtnIcon]="'far-search'"
            [appendBtnTitle]="'automatic-orders.product.search' | translate"
            [appendBtnClasses]="['btn-search']"
            (onAppendBtnEvent)="productSearchChange()"
            (onKeyPress)="productSearchChange()"
          ></form-row-input>
        </div>
      </div>
      <div class="row" *ngIf="searchTab === 'hs'">
        <div class="col-12">
          <form-row-input
            #searchInputInModal
            [label]="'automatic-orders.product.search' | translate"
            [model]="searchPhrase"
            (modelChange)="searchPhrase = $event; templateSearchChange()"
            [appendBtnIcon]="'far-search'"
            [appendBtnTitle]="'automatic-orders.product.search' | translate"
            [appendBtnClasses]="['btn-search']"
            (onAppendBtnEvent)="templateSearchChange()"
            (onKeyPress)="templateSearchChange()"
          ></form-row-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div
            class="search-progress-bar"
            [class.active]="totalLoadingProgress.isTotalLoading"
            [class.indeterminate]="totalLoadingProgress.isTotalLoading && totalLoadingProgress.percentage === 0"
          >
            <div class="search-progress-bar-fill" [style.width.%]="totalLoadingProgress.percentage"></div>
          </div>
        </div>
      </div>
      <div *ngIf="searchTab === 'own'">
        <div class="row" *ngIf="isLoading">
          <div class="col">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th scope="col" class="text-left" colspan="2">
                      {{ 'product.template.name' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.product.search.codeREF' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'quantityStock' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'purchase.price.pack' | translate }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div class="empty-list gray">
                        <!--                      fuck this shit:-->
                        <!--                      <loading-spinner [isLoading]="true" [classesString]="'spinner-box'"></loading-spinner>-->
                        <div class="spin spinner-box">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">{{ 'loading-spinner.loading' | translate }}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="!isLoading">
          <div class="col">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th scope="col" class="text-left" colspan="2">
                      {{ 'product.template.name' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.product.search.codeREF' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.quantityStock.evidentist' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.quantityStock.hs' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'discount' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'purchase.price.pack' | translate }}
                    </th>
                  </tr>
                </thead>

                <tbody *ngIf="searchPhrase?.length < 1 && products?.length === 0">
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div>
                        <i class="far fa-5x fa-arrow-up gray"></i>
                      </div>
                      <div class="empty-list gray">
                        {{ 'automatic-orders.product.search.doSearch' | translate }}
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="searchPhrase?.length > 0 && products?.length === 0 && isNotFound">
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div>
                        <i class="far fa-5x fa-box-open gray"></i>
                      </div>
                      <div class="empty-list gray">
                        {{ 'automatic-orders.product.search.emptySearch' | translate }}
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="products?.length > 0" class="images" [photoGalleryGroup]="{ index: 1 }">
                  <ng-container *ngFor="let prod of products">
                    <tr [ngClass]="{ 'no-click': prod.isLoadingDetails }">
                      <td>
                        <div
                          [photoGallery]="getThumbUrl(prod.mainImage, 'w2048wp')"
                          [photoGalleryCaption]="
                            prod.name +
                            '<br>' +
                            (prod.code ? ('product-template-selection.code' | translate) + prod.code : '') +
                            '<br>' +
                            (prod.ean ? ('product-template-selection.ean' | translate) + prod.ean : '')
                          "
                        >
                          <div class="images-item">
                            <img class="images-item-image" [src]="getThumbUrl(prod.mainImage)" [alt]="prod.name" />
                          </div>
                        </div>
                      </td>
                      <td class="pl-1" (click)="selectProduct(prod)">
                        <span class="cursor-pointer link-bold">
                          {{ prod.name ? prod.name : '' }}
                        </span>
                      </td>
                      <td (click)="selectProduct(prod)">
                        {{ prod.code3 }}
                      </td>
                      <td (click)="selectProduct(prod)">
                        <span> {{ prod.quantityAvailable }} ks </span>
                      </td>
                      <td (click)="selectProduct(prod)">
                        <ng-container *ngIf="!prod.isLoadingDetails; else smallSpinner">
                          <span *ngIf="prod.quantityHs === undefined" class="text-red">-</span>
                          <span
                            *ngIf="prod.quantityHs === 'notConnected' || prod.quantityHs === 'nonSellable'"
                            class="text-red"
                          >
                            {{ prod.quantityHs | translate }}
                          </span>
                          <span *ngIf="prod.quantityHs > 30" class="text-green">{{
                            'product.quantity.moreThan100' | translate
                          }}</span>
                          <span *ngIf="prod.quantityHs > 0 && prod.quantityHs <= 30" class="text-yellow"
                            >{{ prod.quantityHs }} ks</span
                          >
                          <span *ngIf="prod.quantityHs <= 0" class="text-red">{{
                            'product.quantity.zero' | translate
                          }}</span>
                        </ng-container>
                      </td>
                      <td class="text-left" (click)="selectProduct(prod)">
                        <ng-container *ngIf="!prod.isLoadingDetails">
                          <div *ngIf="prod.discount > 0" class="discount-badge">-{{ prod.discount }}%</div>
                        </ng-container>
                      </td>
                      <td class="text-left" (click)="selectProduct(prod)">
                        <ng-container *ngIf="!prod.isLoadingDetails">
                          <span *ngIf="prod.purchasePriceWithVatAndDiscount > 0">
                            {{ prod.purchasePriceWithVatAndDiscount | formatPrice: purchaseCurrencyFromCompany }}
                          </span>
                          <span *ngIf="!prod.purchasePriceWithVatAndDiscount">
                            {{
                              isCountByPieces(prod)
                                ? (prod.packs?.[0]?.quantity * (prod.purchasePrice / prod.vat.coefficient)
                                  | formatPrice: purchaseCurrencyFromCompany)
                                : ''
                            }}
                            {{
                              !isCountByPieces(prod)
                                ? (prod.purchasePrice / prod.vat.coefficient | formatPrice: purchaseCurrencyFromCompany)
                                : ''
                            }}
                          </span>
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="searchTab === 'hs'">
        <div class="row" *ngIf="isLoading">
          <div class="col">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <!--                  <th class="fixed-column-width" scope="col">&nbsp;</th>-->
                    <th scope="col" class="text-left" colspan="2">
                      {{ 'product.template.name' | translate }}
                    </th>
                    <th scope="col" class="cursor-pointer text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.product.search.codeREF' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.quantityStock.evidentist' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.quantityStock.hs' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'discount' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'purchase.price.pack' | translate }}
                    </th>
                    <th class="fixed-column-width" scope="col">&nbsp;</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div class="empty-list gray">
                        <!--                      fuck this shit:-->
                        <!--                      <loading-spinner [isLoading]="true" [classesString]="'spinner-box'"></loading-spinner>-->
                        <div class="spin spinner-box">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">{{ 'loading-spinner.loading' | translate }}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="!isLoading">
          <div class="col">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <!--                  <th class="fixed-column-width" scope="col">&nbsp;</th>-->
                    <th scope="col" class="text-left" colspan="2">
                      {{ 'product.template.name' | translate }}
                    </th>
                    <th scope="col" class="cursor-pointer text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.product.search.codeREF' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.quantityStock.evidentist' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.quantityStock.hs' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'discount' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'purchase.price.pack' | translate }}
                    </th>
                    <th class="fixed-column-width" scope="col">&nbsp;</th>
                  </tr>
                </thead>

                <tbody *ngIf="searchPhrase?.length < 1 && templates?.length === 0">
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div>
                        <i class="far fa-5x fa-arrow-up gray"></i>
                      </div>
                      <div class="empty-list gray">
                        {{ 'automatic-orders.product.search.doSearch' | translate }}
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="searchPhrase?.length > 0 && templates?.length === 0 && isNotFound">
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div>
                        <i class="far fa-5x fa-box-open gray"></i>
                      </div>
                      <div class="empty-list gray">
                        {{ 'automatic-orders.product.search.emptySearch' | translate }}
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="templates?.length > 0" class="images" [photoGalleryGroup]="{ index: 1 }">
                  <tr *ngFor="let template of templates" [ngClass]="{ 'no-click': template.isLoadingDetails }">
                    <td>
                      <div
                        [photoGallery]="getThumbUrl(template.images?.[0], 'w2048wp')"
                        [photoGalleryCaption]="
                          template.name +
                          '<br>' +
                          (template.code ? ('product-template-selection.code' | translate) + template.code : '') +
                          '<br>' +
                          (template.ean ? ('product-template-selection.ean' | translate) + template.ean : '')
                        "
                      >
                        <div class="images-item">
                          <img
                            class="images-item-image"
                            [src]="getThumbUrl(template.images?.[0])"
                            [alt]="template.name"
                          />
                        </div>
                      </div>
                    </td>
                    <td class="pl-1" (click)="selectTemplate(template)">
                      <span class="cursor-pointer link-bold">
                        {{ template.name ? template.name : '' }}
                      </span>
                    </td>
                    <td>
                      {{ template.manuCode }}
                    </td>
                    <td (click)="selectTemplate(template)">
                      <!--                      this is reversed on template: qAvail is from hs..-->
                      <ng-container *ngIf="!template.isLoadingDetails">
                        <span> {{ template.quantityEvidentist }} ks </span>
                      </ng-container>
                    </td>
                    <td (click)="selectTemplate(template)">
                      <ng-container *ngIf="!template.isLoadingDetails; else smallSpinner">
                        <span *ngIf="template.quantityAvailable === undefined" class="text-red">-</span>
                        <span
                          *ngIf="
                            template.quantityAvailable === 'notConnected' ||
                            template.quantityAvailable === 'nonSellable'
                          "
                          class="text-red"
                        >
                          {{ template.quantityAvailable | translate }}
                        </span>
                        <span *ngIf="template.quantityAvailable > 30" class="text-green">{{
                          'product.quantity.moreThan100' | translate
                        }}</span>
                        <span
                          *ngIf="template.quantityAvailable > 0 && template.quantityAvailable <= 30"
                          class="text-yellow"
                          >{{ template.quantityAvailable }} ks</span
                        >
                        <span *ngIf="template.quantityAvailable <= 0" class="text-red">{{
                          'product.quantity.zero' | translate
                        }}</span>
                      </ng-container>
                    </td>
                    <td class="text-left" (click)="selectTemplate(template)">
                      <ng-container *ngIf="!template.isLoadingDetails">
                        <div *ngIf="template.discount > 0" class="discount-badge">-{{ template.discount }}%</div>
                      </ng-container>
                    </td>
                    <td class="text-left" (click)="selectTemplate(template)">
                      <ng-container *ngIf="!template.isLoadingDetails">
                        <span *ngIf="template.purchasePriceWithVatAndDiscount > 0">
                          {{ template.purchasePriceWithVatAndDiscount | formatPrice: purchaseCurrencyFromCompany }}
                        </span>
                        <span *ngIf="!template.purchasePriceWithVatAndDiscount">
                          {{ template.purchasePrice | formatPrice: purchaseCurrencyFromCompany }}
                          <!--                        {{ template.purchasePrice / template.vat.coefficient | formatPrice: purchaseCurrencyFromCompany }}-->
                        </span>
                      </ng-container>
                    </td>
                    <td class="pr-1 text-right fixed-column-width">
                      <btn
                        [label]="'add'"
                        [classes]="['btn-second', 'btn-sm']"
                        [isLoading]="template.isLoadingDetails"
                        (onEvent)="selectTemplate(template)"
                        data-cy="select-template"
                      ></btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!--  connect product to hs template confirmation:-->
  <ng-container class="modal-body-content" *ngIf="modalContent === 'connect-confirm'">
    <div class="p-5">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <div class="mb-4">
          <i class="far fa-5x fa-box-open gray"></i>
        </div>
        <div class="text-bold text-lg mb-4">
          {{ 'purchaseOrder.product.notConnectedToHSTemplate' | translate }}
        </div>
        <div class="product-to-connect mb-4">
          {{ productToConnectWithHsTemplate.name }}
        </div>
        <div class="mb-4">
          {{ 'purchaseOrder.product.notConnectedToHSTemplate2' | translate }}
        </div>
        <div class="mb-4">
          <btn
            [label]="'purchaseOrder.product.notConnectedToHSTemplate.btnSearch'"
            [classes]="['btn-first', 'btn-lg']"
            (onEvent)="modalContent = 'connect-choose'"
            data-cy="select-prod-to-connect-with-template-ok"
          ></btn>
        </div>
        <div
          (click)="modalContent = 'search-tabs'"
          (keyup)="modalContent = 'search-tabs'"
          tabindex="-1"
          class="link text-red mb-4 text-underline"
        >
          {{ 'purchaseOrder.product.notConnectedToHSTemplate.btnBack' | translate }}
        </div>
      </div>
    </div>
  </ng-container>

  <!--  select the hs template to connect with product:-->
  <ng-container class="modal-body-content" *ngIf="modalContent === 'connect-choose'">
    <div class="card">
      <div class="row">
        <div class="col-12">
          <form-row-input
            #searchInputInModal
            [label]="'automatic-orders.product.search' | translate"
            [model]="searchPhrase"
            (modelChange)="searchPhrase = $event; templateSearchChange()"
            [appendBtnIcon]="'far-search'"
            [appendBtnTitle]="'automatic-orders.product.search' | translate"
            [appendBtnClasses]="['btn-search']"
            (onAppendBtnEvent)="templateSearchChange()"
            (onKeyPress)="templateSearchChange()"
          ></form-row-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div
            class="search-progress-bar"
            [class.active]="totalLoadingProgress.isTotalLoading"
            [class.indeterminate]="totalLoadingProgress.isTotalLoading && totalLoadingProgress.percentage === 0"
          >
            <div class="search-progress-bar-fill" [style.width.%]="totalLoadingProgress.percentage"></div>
          </div>
        </div>
      </div>
      <div>
        <div class="row" *ngIf="isLoading">
          <div class="col">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <!--                  <th class="fixed-column-width" scope="col">&nbsp;</th>-->
                    <th scope="col" class="text-left" colspan="2">
                      {{ 'product.template.name' | translate }}
                    </th>
                    <th scope="col" class="cursor-pointer text-nowrap d-none d-xl-table-cell">
                      {{ 'automatic-orders.product.search.codeREF' | translate }}
                    </th>
                    <th class="fixed-column-width" scope="col">&nbsp;</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div class="empty-list gray">
                        <!--                      fuck this shit:-->
                        <!--                      <loading-spinner [isLoading]="true" [classesString]="'spinner-box'"></loading-spinner>-->
                        <div class="spin spinner-box">
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">{{ 'loading-spinner.loading' | translate }}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="!isLoading">
          <div class="col">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <!--                  <th class="fixed-column-width" scope="col">&nbsp;</th>-->
                    <th scope="col" class="text-left" colspan="2">
                      {{ 'product.template.name' | translate }}
                    </th>
                    <th scope="col" class="cursor-pointer text-nowrap d-none d-xl-table-cell">
                      {{ 'automatic-orders.product.search.codeREF' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.quantityStock.evidentist' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'automatic-orders.quantityStock.hs' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'discount' | translate }}
                    </th>
                    <th scope="col" class="text-nowrap d-xl-table-cell">
                      {{ 'purchase.price.pack' | translate }}
                    </th>
                    <th class="fixed-column-width" scope="col">&nbsp;</th>
                  </tr>
                </thead>

                <tbody *ngIf="searchPhrase?.length < 1 && templates?.length === 0">
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div>
                        <i class="far fa-5x fa-arrow-up gray"></i>
                      </div>
                      <div class="empty-list gray">
                        {{ 'automatic-orders.product.search.doSearch' | translate }}
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="searchPhrase?.length > 0 && templates?.length === 0 && isNotFound">
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div>
                        <i class="far fa-5x fa-box-open gray"></i>
                      </div>
                      <div class="empty-list gray">
                        {{ 'automatic-orders.product.search.emptySearch' | translate }}
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="templates?.length > 0" class="images" [photoGalleryGroup]="{ index: 1 }">
                  <tr *ngFor="let template of templates" [ngClass]="{ 'no-click': template.isLoadingDetails }">
                    <td>
                      <div
                        [photoGallery]="getThumbUrl(template.images?.[0], 'w2048wp')"
                        [photoGalleryCaption]="
                          template.name +
                          '<br>' +
                          (template.code ? ('product-template-selection.code' | translate) + template.code : '') +
                          '<br>' +
                          (template.ean ? ('product-template-selection.ean' | translate) + template.ean : '')
                        "
                      >
                        <div class="images-item">
                          <img
                            class="images-item-image"
                            [src]="getThumbUrl(template.images?.[0])"
                            [alt]="template.name"
                          />
                        </div>
                      </div>
                    </td>
                    <td class="pl-1" (click)="connectTemplateToProduct(template)">
                      <span class="cursor-pointer link-bold">
                        {{ template.name ? template.name : '' }}
                      </span>
                    </td>
                    <td>
                      {{ template.manuCode }}
                    </td>
                    <td (click)="connectTemplateToProduct(template)">
                      <!--                      this is reversed on template: qAvail is from hs..-->
                      <ng-container *ngIf="!template.isLoadingDetails">
                        <span> {{ template.quantityEvidentist }} ks </span>
                      </ng-container>
                    </td>
                    <td (click)="connectTemplateToProduct(template)">
                      <ng-container *ngIf="!template.isLoadingDetails; else smallSpinner">
                        <span *ngIf="template.quantityAvailable === undefined" class="text-red">-</span>
                        <span
                          *ngIf="
                            template.quantityAvailable === 'notConnected' ||
                            template.quantityAvailable === 'nonSellable'
                          "
                          class="text-red"
                        >
                          {{ template.quantityAvailable | translate }}
                        </span>
                        <span *ngIf="template.quantityAvailable > 30" class="text-green">{{
                          'product.quantity.moreThan100' | translate
                        }}</span>
                        <span
                          *ngIf="template.quantityAvailable > 0 && template.quantityAvailable <= 30"
                          class="text-yellow"
                          >{{ template.quantityAvailable }} ks</span
                        >
                        <span *ngIf="template.quantityAvailable <= 0" class="text-red">{{
                          'product.quantity.zero' | translate
                        }}</span>
                      </ng-container>
                    </td>
                    <td class="text-left" (click)="connectTemplateToProduct(template)">
                      <ng-container *ngIf="!template.isLoadingDetails">
                        <div *ngIf="template.discount > 0" class="discount-badge">-{{ template.discount }}%</div>
                      </ng-container>
                    </td>
                    <td class="text-left" (click)="connectTemplateToProduct(template)">
                      <ng-container *ngIf="!template.isLoadingDetails">
                        <span *ngIf="template.purchasePriceWithVatAndDiscount > 0">
                          {{ template.purchasePriceWithVatAndDiscount | formatPrice: purchaseCurrencyFromCompany }}
                        </span>
                        <span *ngIf="!template.purchasePriceWithVatAndDiscount">
                          {{ template.purchasePrice | formatPrice: purchaseCurrencyFromCompany }}
                          <!--                        {{ template.purchasePrice / template.vat.coefficient | formatPrice: purchaseCurrencyFromCompany }}-->
                        </span>
                      </ng-container>
                    </td>
                    <td class="pr-1 text-right fixed-column-width">
                      <btn
                        [label]="'select'"
                        [classes]="['btn-second', 'btn-sm']"
                        [isLoading]="template.isLoadingDetails"
                        (onEvent)="connectTemplateToProduct(template)"
                        data-cy="select-template"
                      ></btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</modal-container>

<ng-template #smallSpinner>
  <div class="spinner-border text-primary spinner-small" role="status">
    <span class="sr-only">{{ 'loading-spinner.loading' | translate }}</span>
  </div>
</ng-template>
